<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      class="ma-0"
    >
      <v-col
        cols="12"
      >
        <v-subheader class="pa-0">
          <v-row
            class="ma-0"
          >
            <span class="title">Informações da compra</span>
            <v-spacer/>
            <v-btn
              color="accent"
              text
              @click="onShoppingCartEditClick"
            >
              Alterar
            </v-btn>
          </v-row>
        </v-subheader>
        <v-card
          width="100%"
        >
          <v-row
            v-if="showProcessings"
            align="center"
            class="fill-height ma-0 pa-4"
          >
            <component
              :is="droneImageryIcon"
              class="mr-4 svg-icon"
            />
            <span class="subtitle-2 grey--text">Processamentos de imagem</span>
            <v-spacer/>
            <v-flex
              class="text-right"
            >
              <span class="body-2 font-weight-bold grey--text">Preço final: </span>
              <span class="body-2 blue--text">{{currencySymbol}} {{processingsFinalPrice | toFixedWithComma}}</span>
            </v-flex>
          </v-row>
          <v-row
            v-if="showPostProcessings"
            align="center"
            class="fill-height ma-0 pa-4"
          >
            <v-icon
              color="green"
              class="mr-4"
            >
              mdi-leaf
            </v-icon>
            <span class="subtitle-2 grey--text">Análises agronômicas</span>
            <v-spacer/>
            <v-flex
              class="text-right"
            >
              <span class="body-2 font-weight-bold grey--text">Preço final: </span>
              <span class="body-2 blue--text">{{currencySymbol}} {{postProcessingsFinalPrice | toFixedWithComma}}</span>
            </v-flex>
          </v-row>
          <v-row
            v-if="showSubscriptions"
            align="center"
            class="fill-height ma-0 pa-4"
          >
            <v-icon
              color="accent"
              class="mr-4"
            >
              mdi-wallet-membership
            </v-icon>
            <span class="subtitle-2 grey--text">Assinaturas</span>
            <v-spacer/>
            <v-flex
              class="text-right"
            >
              <span class="body-2 font-weight-bold grey--text">Preço final: </span>
              <span class="body-2 blue--text">{{currencySymbol}} {{subscriptionsFinalPrices | toFixedWithComma}}</span>
            </v-flex>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="12"
      >
        <v-subheader class="pa-0">
          <v-row
            class="ma-0"
          >
            <span class="title">Método de pagamento</span>
            <v-spacer/>
            <v-btn
              color="accent"
              text
              @click="onPaymentMethodEditClick"
            >
              Alterar
            </v-btn>
          </v-row>
        </v-subheader>
        <v-card
          width="100%"
          height="80px"
        >
          <v-row
            v-if="!resumeCardDataIsEmpty || paymentMethodIsCreditCard || paymentMethodIsSavedCreditCard"
            align="center"
            class="fill-height ma-0 px-4"
          >
            <div :class="['mr-4', creditCardLogo]"></div>
            <v-flex
              class="d-flex flex-column"
            >
              <span class="subtitle-2 grey--text">{{creditCardText}}</span>
              <span class="caption grey--text font-weight-light">{{installmentsDisplay(PaymentMixin.resumeInstallmentsInfo)}}</span>
            </v-flex>
          </v-row>
          <v-row
            v-else
            align="center"
            class="fill-height ma-0 px-4"
          >
            <v-icon left>mdi-barcode</v-icon>
            <span class="subtitle-2 grey--text">Boleto Bancário</span>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        v-if="!resumePayerInfoIsEmpty"
        cols="12"
      >
        <v-subheader class="pa-0">
          <v-row
            class="ma-0"
          >
            <span class="title">Informações do Pagador</span>
            <v-spacer/>
            <v-btn
              color="accent"
              text
              @click="onPayerInfoEditClick"
            >
              Alterar
            </v-btn>
          </v-row>
        </v-subheader>
        <v-card
          width="100%"
          height="80px"
        >
          <v-row
            align="center"
            class="fill-height ma-0 px-4"
          >
            <v-icon
              color="accent"
              class="mr-4"
            >
              mdi-account-cash-outline
            </v-icon>
            <v-flex
              class="d-flex flex-column"
            >
              <span class="subtitle-2 grey--text">{{PaymentMixin.resumePayerInfo["strName"]}} - CPF {{PaymentMixin.resumePayerInfo["strDocumentNumber"]}}</span>
              <span class="subtitle-2 grey--text">{{PaymentMixin.resumePayerInfo["strEmail"]}}</span>
            </v-flex>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        v-if="!resumeNfeInfoIsEmpty"
        cols="12"
      >
        <v-subheader class="pa-0">
          <v-row
            class="ma-0"
          >
            <span class="title">Informações para Nota Fiscal</span>
            <v-spacer/>
            <v-btn
              color="accent"
              text
              @click="onNfeInfoEditClick"
            >
              Alterar
            </v-btn>
          </v-row>
        </v-subheader>
        <v-card
          width="100%"
          height="80px"
        >
          <v-row
            align="center"
            class="fill-height ma-0 px-4"
          >
            <v-icon
              color="accent"
              class="mr-4"
            >
              mdi-receipt
            </v-icon>
            <v-flex
              class="d-flex flex-column"
            >
              <span class="subtitle-2 grey--text">{{PaymentMixin.resumeNfeInfo["strName"]}} - CPF {{PaymentMixin.resumeNfeInfo["strDocumentNumber"]}}</span>
              <span class="subtitle-2 grey--text">{{PaymentMixin.resumeNfeInfo["strZipCode"]}}</span>
            </v-flex>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      class="ma-0 my-2"
    >
      <v-divider/>
    </v-row>
    <v-row
      class="ma-0"
    >
      <v-btn
        :disabled="PaymentMixin.isPaying"
        color="accent"
        outlined
        @click="this.LastStep"
      >
        Voltar
      </v-btn>
      <v-spacer/>
      <v-btn
        color="success"
        @click="onNextClick"
        :loading="PaymentMixin.isPaying"
      >
        Confirmar pagamento
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  import {isEmpty, isEqual} from "lodash/lang"
  import {forEach} from "lodash/collection"
  import {CREDIT_CARD_LOGO, PAYMENT_METHOD, PAYMENT_STEPS} from "../../helpers/payment/constants"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {toFixed} from "../../helpers/utils"

  const PaymentLastStep = Symbol.for("PaymentLastStep")
  const PaymentSetStep = Symbol.for("PaymentSetStep")
  const _PaymentMixin = Symbol.for("_PaymentMixin")
  const InitPayment = Symbol.for("InitPayment")

  export default {
    name: "PaymentSummary",
    inject: {_PaymentMixin, LastStep: PaymentLastStep, SetStep: PaymentSetStep, InitPayment},
    methods: {
      onNextClick() {
        this.InitPayment(this.$apiAuth.getAuthToken())
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Compra realizada com sucesso, redirecionando",
              type: NOTIFICATION_TYPES.SUCCESS
            }))
            setTimeout(() => {
              this.$router.push("/app/processing-list")
            }, 3000)
          })
      },
      onShoppingCartEditClick() {
        this.SetStep(PAYMENT_STEPS.SHOPPING_CART)
      },
      onPaymentMethodEditClick() {
        this.SetStep(PAYMENT_STEPS.PAYMENT_METHOD)
      },
      onPayerInfoEditClick() {
        this.SetStep(PAYMENT_STEPS.PAYER_INFO)
      },
      onNfeInfoEditClick() {
        this.SetStep(PAYMENT_STEPS.NFE_INFO)
      },
      installmentsDisplay(installment) {
        if (!installment) return `1 x R$ ${this.shoppingCartFinalPrice} - Sem juros`
        let strFee = ''
        if (installment["interestFree"])
          strFee = 'Sem juros'
        else
          strFee = 'Com juros'
        return `${installment["quantity"]} x R$ ${installment["installmentAmount"]} - ${strFee}`
      }
    },
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      resumeCardDataIsEmpty() {
        return isEmpty(this.PaymentMixin.resumeCardData)
      },
      resumePayerInfoIsEmpty() {
        return isEmpty(this.PaymentMixin.resumePayerInfo)
      },
      resumeNfeInfoIsEmpty() {
        return isEmpty(this.PaymentMixin.resumeNfeInfo)
      },
      creditCardText() {
        if (isEmpty(this.PaymentMixin.resumeCardData)) return ""
        return `**** **** **** ${this.PaymentMixin.resumeCardData["strLastDigits"]}`
      },
      creditCardLogo() {
        if (isEmpty(this.PaymentMixin.resumeCardData)) return "card-logo small unknown"
        return CREDIT_CARD_LOGO[this.PaymentMixin.resumeCardData["strCcBrand"]] || "card-logo small unknown"
      },
      paymentMethodIsCreditCard() {
        return isEqual(this.PaymentMixin.paymentMethod, PAYMENT_METHOD.CREDIT_CARD)
      },
      paymentMethodIsSavedCreditCard() {
        return isEqual(this.PaymentMixin.paymentMethod, PAYMENT_METHOD.SAVED_CREDIT_CARD)
      },
      PaymentMixin() {
        return this._PaymentMixin()
      },
      droneImageryIcon() {
        const SVGIcon = require("../../assets/processings/drone-imagery.svg?inline")
        return SVGIcon.default
      },
      showProcessings() {
        if (!this.PaymentMixin.shoppingCart) return false
        return !isEmpty(this.PaymentMixin.shoppingCart["processing_cart"]);
      },
      shoppingCartFinalPrice() {
        if (!this.PaymentMixin.shoppingCart) return toFixed(0, 2).replace(".", ",")
        return toFixed(this.PaymentMixin.shoppingCart["fl_final_price"], 2).replace(".", ",")
      },
      processingsFinalPrice() {
        if (!this.PaymentMixin.shoppingCart) return 0
        if (isEmpty(this.PaymentMixin.shoppingCart["processing_cart"])) return 0

        let finalPrice = 0
        forEach(this.PaymentMixin.shoppingCart["processing_cart"], item => {
          finalPrice += item["fl_final_price"]
        })
        return finalPrice
      },
      showPostProcessings() {
        if (!this.PaymentMixin.shoppingCart) return false
        return !isEmpty(this.PaymentMixin.shoppingCart["post_processing_cart"]);
      },
      postProcessingsFinalPrice() {
        if (!this.PaymentMixin.shoppingCart) return 0
        if (isEmpty(this.PaymentMixin.shoppingCart["post_processing_cart"])) return 0

        let finalPrice = 0
        forEach(this.PaymentMixin.shoppingCart["post_processing_cart"], item => {
          finalPrice += item["fl_final_price"]
        })
        return finalPrice
      },
      showSubscriptions() {
        if (!this.PaymentMixin.shoppingCart) return false
        return !isEmpty(this.PaymentMixin.shoppingCart["subscription_cart"]);
      },
      subscriptionsFinalPrices() {
        if (!this.PaymentMixin.shoppingCart) return 0
        if (isEmpty(this.PaymentMixin.shoppingCart["subscription_cart"])) return 0

        let finalPrice = 0
        forEach(this.PaymentMixin.shoppingCart["subscription_cart"], item => {
          finalPrice += item["fl_final_price"]
        })
        return finalPrice
      },
      currencySymbol() {
        if (this.$appMng.isIntl)
          return "$"
        return "R$"
      },
    }
  }
</script>

<style scoped lang="scss">
  .svg-icon {
    width: 24px;
    height: 24px;

    fill: var(--v-accent-base);
  }
</style>
